import SigliveServiceV1 from 'Service/sigliveServiceV1';

const getAvailableAccount = async (queries = '') => {
  const { data } = await SigliveServiceV1({ method: 'GET', url: `/schedule-ruleset/available-accounts?${queries}` });

  return data?.data;
};

export default getAvailableAccount;
